import React from 'react';

export default class ResetButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      now: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }
  }
  updateNow = ({ target: { checked } }) => this.setState({ now: checked });
  updateDays = ({ target: { value } }) => this.setState({ days: parseInt(value, 10) });
  updateHours = ({ target: { value } }) => this.setState({ hours: parseInt(value, 10) });
  updateMinutes = ({ target: { value } }) => this.setState({ minutes: parseInt(value, 10) });
  updateSeconds = ({ target: { value } }) => this.setState({ seconds: parseInt(value, 10) });
  calculateDelay = () => {
    const { days, hours, minutes, seconds, now } = this.state;
    if (now) return 0;
    let delay = 0;
    delay += days*1000*60*60*24;
    delay += hours*1000*60*60;
    delay += minutes*1000*60;
    delay += seconds*1000;
    return delay;
  }
  render(){
    const {
      calculateDelay,
      updateNow,
      updateDays,
      updateHours,
      updateMinutes,
      updateSeconds,
      props: { reset, text = 'Reset' },
      state: { now, days, minutes, hours, seconds }
    } = this;

    const delay = calculateDelay();
    return (
      <div className="reset-button">
        <div className='controls'>
          <button onClick={() => reset(delay)}>{text}</button>  
          <label className="show-time">
            Now? <input type='checkbox' checked={now} onChange={updateNow} />
          </label>
        </div>
        {!now && (
          <>
            <div>
              Reset to how long ago?
            </div>
            <div>
              <span>Days:</span>
              <input type='number' value={days} onChange={updateDays} />
            </div>
            <div>
              <span>Hours:</span>
              <input type='number' value={hours} onChange={updateHours} />
            </div>
            <div>
              <span>Minutes:</span>
              <input type='number' value={minutes} onChange={updateMinutes} />
            </div>
            <div>
              <span>Seconds:</span>
              <input type='number' value={seconds} onChange={updateSeconds} />
            </div>
          </> 
        )}
      </div>
    );
  }
}